module.exports = __webpack_public_path__ + "static/media/tya202.89002be8.pdf";